import React, { useState } from 'react'
import { Box, IconButton, TextField, Tooltip } from '@mui/material'
import SendIcon from '@mui/icons-material/Send'
import StopIcon from '@mui/icons-material/Stop'

interface CopilotComposerProps {
  isStreaming: boolean
  onSend: (text: string) => void
  onStop: () => void
  disabled?: boolean
}

const CopilotComposer: React.FC<CopilotComposerProps> = ({
  isStreaming,
  onSend,
  onStop,
  disabled = false,
}) => {
  const [text, setText] = useState('')

  const handleSend = () => {
    const trimmed = text.trim()
    if (!trimmed || isStreaming || disabled) return
    onSend(trimmed)
    setText('')
  }

  return (
    <Box
      display="flex"
      gap={1}
      alignItems="flex-end"
      sx={{ p: 1.5, borderTop: '1px solid', borderColor: 'divider' }}
    >
      <TextField
        fullWidth
        size="small"
        multiline
        maxRows={5}
        placeholder="Describe what to build or change…"
        value={text}
        disabled={disabled}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            handleSend()
          }
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'background.custom3',
            borderRadius: '8px',
          },
        }}
      />
      {isStreaming ? (
        <Tooltip title="Stop">
          <IconButton color="primary" onClick={onStop}>
            <StopIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Send">
          <span>
            <IconButton color="primary" disabled={!text.trim() || disabled} onClick={handleSend}>
              <SendIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  )
}

export default CopilotComposer
